// API URL configuration for fetch requests
// HARDCODED para Railway ya que process.env no funciona correctamente en build

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
// Detect private network IPs (same LAN development: 192.168.x.x, 10.x.x.x, 172.16-31.x.x)
const isPrivateIP = /^10\./.test(hostname) || /^192\.168\./.test(hostname) || /^172\.(1[6-9]|2[0-9]|3[01])\./.test(hostname);
const isLocalDev = isLocalhost || isPrivateIP;

// Capacitor native detection (solo cuando realmente corre en esquema capacitor)
const isNativeCapacitor =
  typeof window !== 'undefined' &&
  !!window.Capacitor &&
  (window.location.protocol === 'capacitor:' || window.location.origin.startsWith('capacitor://'));

// Detectar si estamos en producción por la URL actual o en Capacitor (APK)
const isProduction =
  typeof window !== 'undefined' &&
  !isLocalDev &&
  (hostname === 'mundoxyz.com' ||
    hostname === 'www.mundoxyz.com' ||
    hostname.endsWith('.mundoxyz.com') ||
    hostname.endsWith('.mundoxyz') ||
    hostname.includes('mundoxyz') ||
    hostname.includes('railway.app') ||
    isNativeCapacitor);

// En producción o Capacitor: usar URL hardcoded
// En desarrollo local/LAN: string vacío (proxy) o IP del host
// En desarrollo localhost: string vacío (proxy)
const API_URL = isNativeCapacitor
  ? (process.env.REACT_APP_API_URL || 'https://mundoxyz.com')
  : isProduction
    ? (window.location.origin || 'https://mundoxyz.com')
    : isPrivateIP
      ? `http://${hostname}:3000`
      : (process.env.REACT_APP_API_URL || '');

console.log('🌍 API_URL configurado:', API_URL);
console.log('🏠 Hostname:', typeof window !== 'undefined' ? window.location.hostname : 'SSR');
console.log('🔧 isProduction:', isProduction);

export default API_URL;
